import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'RRKeys' })
export class RRKeysPipe implements PipeTransform {
  transform(value: (Number | string)[], _args: string[]): any {
    const keys = [];
    for (const enumMember in value) {
      if (!isNaN(parseInt(enumMember, 10))) {
        keys.push({ key: value[enumMember], value: enumMember });
      }
    }
    return keys;
  }
}
